import { createContext } from 'react'

export const GlobalContext = createContext()

export default GlobalContext
